import { render, staticRenderFns } from "./TableMedicalRecord.vue?vue&type=template&id=951f8370&"
import script from "./TableMedicalRecord.vue?vue&type=script&lang=js&"
export * from "./TableMedicalRecord.vue?vue&type=script&lang=js&"
import style0 from "./TableMedicalRecord.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports